import React, { Fragment } from 'react';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import aImg from '../../images/about/about_buildlab_team.jpg'
import teamBannerImg from '../../images/about/about_team_banner.jpg'
import PolicySection from './Policy';
import WhyUs from './WhyUs';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import CtaSection from '../../components/CtaSection/CtaSection';


const AboutUsPage = (props) => {

    usePageSeo({
        title: 'About BUILDLAB',
        description: 'BUILDLAB is a California technology consulting firm — low-voltage and surveillance design for affordable housing, plus managed IT, cyber security, and AI.',
        keywords: 'about BUILDLAB, technology consulting, construction tech design, managed IT, affordable housing, AI integration',
    });
    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content about-page">
                <PageTitle pageTitle={'About Us'} pagesub={'More BUILDLAB '} pageTop={'About'} bgImage={teamBannerImg}/>
                <section className="intro_about_section section_space bg-light">
                    <div className="intro_about_content">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="image_wrap">
                                        <img src={aImg} alt="BUILDLAB - About " />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="image_wrap">
                                        <video
                                            src={`${process.env.PUBLIC_URL}/videos/buildlab_about.mp4`}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="heading_block mb-0">
                            <div className="row justify-content-lg-between">
                                <div className="col-lg-4">
                                    <div className="heading_focus_text">
                                        About
                                        <span className="badge bg-secondary text-white">BUILDLAB </span>
                                    </div>
                                    <h2 className="heading_text mb-0">
                                        We Provide You Flexible Services
                                    </h2>
                                </div>
                                <div className="col-lg-6">
                                    <p className="heading_description mb-0">
                                        At BUILDLAB, we serve clients across California, working two tracks under one roof. For construction projects, we design and coordinate the building's technology — low-voltage and structured cabling, surveillance, door access, fire & life safety, and computer networks for residences and common areas. For businesses, we run the day-to-day technology that powers your operations — systems and network administration, cyber security, IT infrastructure and cloud, web development, marketing and SEO, and AI Business Integration to automate workflows and train your team on practical AI usage.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <PolicySection />
                <FeaturesSection />
                <WhyUs />
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutUsPage;
